var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":"primary","disabled":_vm.sending,"loading":_vm.loading,"plain":""},on:{"click":_vm.sendMsgCode}},[_vm._v(_vm._s(_vm.btnText))])}
var staticRenderFns = []

export { render, staticRenderFns }